import { gql } from '@apollo/client'

export const GET_PRODUCT_GENERIC_CODES = gql`
  query GetProductGenericCodes {
    getProductGenericCodes
  }
`

export const GET_PRODUCT_FILTER_OPTIONS = gql`
  query GetProductFilterOptions {
    getProductFilterOptions {
      generic_code
      product_category_id
      category_name
      product_sub_category_id
      product_sub_category_name
    }
  }
`

export const GET_ELEMENTS = gql`
  query GetElements {
    elements {
      id
      element_name
      element_abr
      element_display_1
      element_display_2
      thickness
      thickness_unit
      element_material {
        id
        material_name
        is_active
      }
      element_type {
        id
        element_type
        element_type_display_order
        is_active
      }
      element_desc
      element_mod {
        id
        element_mod_type {
          id
          element_mod_type
        }
        element_mod_details
        internal_note
      }
      frl
      frl_st
      frl_integ
      frl_ins
      base_thickness
      added_thickness
      image1
      drawing
      is_active
      inserted_on
      modified_on
      element_notes {
        element_id
        id
        inserted_on
        is_active
        modified_on
        notes
      }
    }
  }
`
export const GET_ELEMENTS_LIMITED = gql`
  query GetElements {
    elements {
      id
      element_name
    }
  }
`
export const GET_ALL_TYPES = gql`
  query GetAllTypes {
    applications {
      application_name
      application_display_order
      id
      is_active
    }
    fixingTested {
      id
      fixing_test_list
      fixing_required
      fixing_note
      internal_note
    }
    elementTypes {
      id
      element_type
      element_orientation {
        orientation
        id
      }
      element_type_display_order
      is_active
    }
    elementMaterials {
      id
      material_name
      material_order
      is_active
    }
    elementOrientations {
      id
      orientation
      is_active
    }
    elementMaterialConf {
      id
      element_material {
        material_name
      }
      element_construction
      element_construction_abr
      is_active
    }
    documentTypes {
      id
      document_type
      doc_type_desc
      is_active
    }
    productTypes {
      id
      product_type
      is_active
    }
    fittingTypes {
      id
      fitting_type
      is_active
    }
    reportTypes {
      id
      report_type
      is_active
    }
    serviceTypes {
      id
      service_type
      description
      is_active
    }
    units {
      id
      unit_name
      is_active
    }
    fixingCategories {
      id
      fixing_category
      is_active
    }
    fixingGroups {
      id
      fixing_group
      is_active
    }
    productManufacturers {
      id
      manufacturer_name
      is_active
    }
    productBrands {
      id
      brand_name
      is_active
    }
    productInstallationTypes {
      id
      installation_type
      is_active
    }
    productCategories {
      id
      category_name
      category_display_order
      is_active
    }
    productSubCategories {
      id
      product_sub_category_name
      product_category {
        id
        category_name
      }
      is_active
      sub_category_display_order
    }
    productInstructionList {
      instruction_code
      id
      is_active
    }
    reportStandardList {
      id
      standard_name
    }
    reportStatuses {
      id
      status
    }
    reportPublishings {
      id
      release
    }
    reportFacilities {
      id
      facility_country
      facility
    }
    serviceCategories {
      id
      category_name
    }
    serviceSubCategories {
      id
      service_sub_cat_name
      is_active
      display_order
    }
    serviceManufacturers {
      id
      service_manufacturer
    }
    serviceMaterials {
      id
      service_material
      notes
      internal_note
    }
    serviceBrands {
      id
      service_brand
      is_active
    }
    serviceStandards {
      id
      service_std_name
    }
    serviceAddTypes {
      id
      service_add_type
    }
    serviceAdds {
      id
      service_add
    }
    serviceAddManufacturers {
      id
      service_add_manufacturer
    }
    serviceAddBrands {
      id
      service_add_brand
    }
    serviceAddGroups {
      id
      service_add_group
    }
    serviceConfigurations {
      is_active
      service_config_name
      config_details
      id
    }
    reportStandardList {
      id
      standard_name
      standard_no
      standard_part
      standard_year
      standard_section
      standard_fullname
      standard_country
      standard_published_date
      is_current
      is_active
      inserted_on
      modified_on
    }
    serviceTypes {
      id
      service_type
    }
    industryCategories {
      id
      industry_category
      is_active
    }
    dimensionTypes {
      id
      dim_type
      dim_description
    }
    documentVersions {
      id
      version_desc
      version_abre
    }
    elementMods {
      id
      element_mod_type {
        id
        element_mod_type
      }
      element_mod_details
      internal_note
      inserted_on
      modified_on
    }
    elementModTypes {
      id
      element_mod_type
      internal_note
      inserted_on
      modified_on
    }
    systemNoteTypes {
      id
      system_note_type
      is_active
      inserted_on
      modified_on
    }
    reports {
      id
      report_name
      report_no
    }
    systemNotes {
      id
      note_title
    }
    systems {
      id
      system_code
    }
  }
`
export const GET_ELEMENT_TYPES = gql`
  query GetElementTypes {
    elementTypes {
      id
      element_type
      element_orientation {
        id
        orientation
      }
      element_type_display_order
      is_active
    }
  }
`
export const GET_ELEMENT_ORIENTATIONS = gql`
  query GetElementOrientations {
    elementOrientations {
      id
      orientation
      is_active
    }
  }
`
export const GET_ELEMENT_MATERIALS = gql`
  query GetElementmaterials {
    elementMaterials {
      id
      material_name
      material_order
      display_status
      is_active
    }
  }
`
export const GET_ELEMENT_MATERIAL_CONF = gql`
  query GetElementmaterialConf {
    elementMaterialConf {
      id
      element_material {
        material_name
      }
      element_construction
      element_construction_abr
      is_active
    }
  }
`
export const GET_ELEMENT_MOD_TYPES = gql`
  query GetElementModTypes {
    elementModTypes {
      id
      element_mod_type
      internal_note
      inserted_on
      modified_on
    }
  }
`
export const GET_ELEMENT_MODS = gql`
  query GetElementMods {
    elementMods {
      id
      element_mod_type {
        id
        element_mod_type
      }
      element_mod_details
      internal_note
      inserted_on
      modified_on
    }
  }
`
export const GET_ELEMENT_NOTES = gql`
  query GetElementNotes {
    elementNotes {
      element_id
      id
      inserted_on
      is_active
      modified_on
      notes
    }
  }
`
export const GET_PRODUCTS = gql`
  query GetProducts {
    products {
      id
      product_code
      product_abr
      product_desc
      generic_code
      product_installation_type {
        id
        installation_type
        is_active
      }
      product_category {
        id
        category_name
        is_active
      }
      product_sub_category {
        id
        product_sub_category_name
        is_active
      }
      selling_price
      nominal_size
      nominal_size_unit
      display_size
      dim_1_name
      dim_1_type {
        id
        dim_type
      }
      dim_1
      dim_1_unit
      dim_2_name
      dim_2_type {
        id
        dim_type
      }
      dim_2
      dim_2_unit
      dim_3_name
      dim_3_type {
        id
        dim_type
      }
      dim_3
      dim_3_unit
      dim_4_name
      dim_4_type {
        id
        dim_type
      }
      dim_4
      dim_4_unit
      product_url
      product_qr_url
      product_manufacturer {
        id
        manufacturer_name
        is_active
      }
      product_brand {
        id
        brand_name
        is_active
      }
      product_type {
        id
        product_type
        is_active
      }
      is_active
      product_notes {
        id
        notes
        is_active
      }
      product_instructions {
        id
        product_instruction_list {
          id
          instruction_code
        }
        is_active
      }
      product_docs {
        id
        is_hero
        document_type {
          id
          document_type
        }
        document_url {
          id
          file_name
          cdn_url
          is_private_file
          uploaded_on
        }
      }
      inserted_on
      modified_on
    }
  }
`

export const GET_PRODUCTS_BY_GENERIC_CODE = gql`
  query GetProductsByGenericCode($generic_code: String!) {
    productsByGenericCode(generic_code: $generic_code) {
      id
      product_code
      product_abr
      product_desc
      generic_code
      product_installation_type {
        id
        installation_type
        is_active
      }
      product_category {
        id
        category_name
        is_active
      }
      product_sub_category {
        id
        product_sub_category_name
        is_active
      }
      selling_price
      nominal_size
      nominal_size_unit
      display_size
      dim_1_name
      dim_1_type {
        id
        dim_type
      }
      dim_1
      dim_1_unit
      dim_2_name
      dim_2_type {
        id
        dim_type
      }
      dim_2
      dim_2_unit
      dim_3_name
      dim_3_type {
        id
        dim_type
      }
      dim_3
      dim_3_unit
      dim_4_name
      dim_4_type {
        id
        dim_type
      }
      dim_4
      dim_4_unit
      product_url
      product_qr_url
      product_manufacturer {
        id
        manufacturer_name
        is_active
      }
      product_brand {
        id
        brand_name
        is_active
      }
      product_type {
        id
        product_type
        is_active
      }
      is_active
      product_notes {
        id
        notes
        is_active
      }
      product_instructions {
        id
        product_instruction_list {
          id
          instruction_code
        }
        is_active
      }
      product_docs {
        id
        is_hero
        document_type {
          id
          document_type
        }
        document_url {
          id
          file_name
          cdn_url
          is_private_file
          uploaded_on
        }
      }
      inserted_on
      modified_on
    }
  }
`

export const GET_SYSTEMS_BY_GENERIC_CODE = gql`
  query GetSystemsByGenericCode($generic_code: String!) {
    getSystemsByGenericCode(generic_code: $generic_code) {
      id
      system_code
      priority_order
      system_description
      service_configuration {
        id
        service_config_name
      }
      application {
        id
        application_name
      }
      industry_category {
        id
        industry_category
      }
      fixing_tested {
        fixing_test_list
        id
      }
      fixing_group {
        id
        fixing_group
      }
      fitting
      fitting_allowed
      fitting_type {
        id
        fitting_type
      }
      fitting_thickness
      penetration_depth
      penetration_depth_unit
      frl_actual
      frl_actual_st
      frl_actual_int
      frl_actual_ins
      frl_issued
      frl_issued_st
      frl_issued_int
      frl_issued_ins
      is_active
      multiple_services
      no_of_services
      system_elements {
        id
        element {
          id
          element_name
          element_abr
        }
        is_primary
      }
      system_products {
        id
        product {
          id
          product_code
          product_abr
        }
      }
      system_reports {
        id
        report {
          id
          report_no
          report_name
        }
        penetration_no
        is_primary
      }
      display_record
      system_component_products {
        id
        component_product {
          id
          comp_product_name
        }
        component_product_details
      }
      system_services {
        id
        service {
          id
          service_name
          service_abr
          service_material {
            id
            service_material
          }
          service_size
          size_unit
        }
        is_range
        range_details
        quantity
      }

      system_docs {
        id
        document_type {
          id
          document_type
        }
        document_url {
          id
          file_name
          cdn_url
          is_private_file
        }
      }
      system_notes {
        id
        notes
        is_active
      }
      inserted_on
      modified_on
    }
  }
`

export const GET_SERVICES = gql`
  query Services {
    services {
      id
      service_name
      service_abr
      service_sub_category {
        id
        service_sub_cat_name
      }
      service_material {
        id
        service_material
      }
      service_size
      nominal_size
      size_unit
      actual_size
      actual_outer_dia
      actual_inner_dia
      thickness
      thickness_unit
      actual_size_tol
      thickness_tol
      service_add {
        id
        service_add
      }
      service_add_dim
      service_add_unit
      service_manufacturer {
        id
        service_manufacturer
      }
      service_brand {
        id
        service_brand
      }
      is_active
      inserted_on
      modified_on
      service_notes {
        id
        notes
        is_active
      }
    }
  }
`
export const GET_PRODUCT_INSTALLATION_TYPES = gql`
  query GetProductInstallationTypes {
    productInstallationTypes {
      id
      installation_type
      is_active
    }
  }
`
export const GET_PRODUCT_TYPES = gql`
  query GetProductTypes {
    productTypes {
      id
      product_type
      is_active
    }
  }
`
export const GET_PRODUCT_CATEGORIES = gql`
  query GetProductCategories {
    productCategories {
      id
      category_name
      category_display_order
      is_active
    }
  }
`
export const GET_PRODUCT_SUB_CATEGORIES = gql`
  query GetProductSubCategories {
    productSubCategories {
      id
      product_sub_category_name
      sub_category_display_order
      sub_category_description
      is_active
      sub_category_docs {
        id
        document_type {
          id
          document_type
        }
        document_url {
          id
          cdn_url
          file_name
          is_private_file
        }
        is_active
        notes
        document_display_order
      }
    }
  }
`
export const GET_PRODUCT_MANUFACTURERS = gql`
  query productManufacturers {
    productManufacturers {
      id
      manufacturer_name
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_PRODUCT_BRANDS = gql`
  query productBrands {
    productBrands {
      id
      brand_name
      is_active
      inserted_on
      modified_on
    }
  }
`

export const GET_PRODUCT_INDUSTRIES = gql`
  query productIndustries {
    productIndustries {
      id
      product {
        id
        product_code
      }
      industry_category {
        id
        industry_category
      }
      inserted_on
      modified_on
    }
  }
`

export const GET_PRODUCT_INSTRUCTION_LIST = gql`
  query productInstructionList {
    productInstructionList {
      id
      instruction_no
      instruction_code
      instruction_desc
      installation_type {
        id
        installation_type
      }
      instruction_doc_url {
        id
        file_name
        cdn_url
        is_private_file
      }
      instruct_external_note
      doc_uploaded_date
      is_active
    }
  }
`
export const GET_PRODUCT_MATCHING_LIST = gql`
  query productMatchingList {
    productMatchingList {
      id
      current_product_id
      system_product_id
      current_product_code
      system_product_code
      external_note
      internal_note
      is_active
    }
  }
`
export const GET_PRODUCT_ACCESSORY_MATCH = gql`
  query productAccessoryMatch {
    productAccessoryMatch {
      id
      accessory
      accessory_id
      product
      product_id
      is_active
      notes
      inserted_on
      modified_on
    }
  }
`
export const GET_PRODUCT_INSTRUCTIONS = gql`
  query productInstructions {
    productInstructions {
      id
      product_id
      product_code
      instruction_id
      instruction_no
      is_active
      notes
    }
  }
`
export const GET_PRODUCT_NOTES = gql`
  query productNotes {
    productNotes {
      id
      product_id
      product_code
      notes
      is_active
    }
  }
`
export const GET_PRODUCT_DOCS = gql`
  query productDocs {
    productDocs {
      id
      product_id
      product_code
      document_type_id
      document_type
      document_url {
        id
        file_name
        cdn_url
        is_private_file
        uploaded_on
      }
      notes
      is_active
    }
  }
`
export const GET_REPORT_TYPES = gql`
  query GetReportTypes {
    reportTypes {
      id
      report_type
      is_active
    }
  }
`
export const GET_REPORT_PUBLISHINGS = gql`
  query GetReportPublishings {
    reportPublishings {
      id
      release
      publishing_details
      is_active
    }
  }
`
export const GET_REPORT_FACILITIES = gql`
  query GetReportFacilities {
    reportFacilities {
      id
      facility
      facility_country
      is_active
    }
  }
`
export const GET_REPORT_STATUSES = gql`
  query GetReportStatuses {
    reportStatuses {
      id
      status
      status_details
      is_active
    }
  }
`
export const GET_REPORT_STANDARD_LIST = gql`
  query GetReportStandardList {
    reportStandardList {
      id
      standard_name
      standard_no
      standard_part
      standard_year
      standard_section
      standard_fullname
      standard_country
      standard_published_date
      is_current
      is_active
    }
  }
`
export const GET_REPORTS = gql`
  query GetReports {
    reports {
      id
      report_no
      report_name
      version_no
      doc_version_desc {
        id
        version_desc
      }
      report_facility {
        id
        facility
      }
      report_type {
        id
        report_type
      }
      report_publishing {
        id
        release
      }
      report_status {
        id
        status
      }
      doc_version_desc {
        id
        version_desc
      }
      test_date
      issue_date
      expiry_date
      superseded_date
      publishing_notes
      is_active
      display_status
      report_doc_url {
        id
        file_name
        cdn_url
        is_private_file
        uploaded_on
      }
      inserted_on
      modified_on
      report_notes {
        id
        notes
        is_active
      }
      report_standards {
        id
        report_standard_list {
          id
          standard_country
          standard_name
        }
        is_active
        modified_on
        report_id
        inserted_on
      }
    }
  }
`
export const GET_REPORT_STANDARDS = gql`
  query GetReportStandards {
    reportStandards {
      id
      report_id
      report_name
      report_standard_id
      standard_name
      is_active
    }
  }
`
export const GET_REPORT_NOTES = gql`
  query GetReportNotes {
    reportNotes {
      id
      report_id
      report_no
      notes
      is_active
    }
  }
`
export const GET_SERVICE_TYPES = gql`
  query GetServiceTypes {
    serviceTypes {
      id
      service_type
      description
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_CATEGORIES = gql`
  query GetServiceCategories {
    serviceCategories {
      id
      category_name
      service_type {
        id
        service_type
      }
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_SUB_CATEGORIES = gql`
  query ServiceCategories {
    serviceSubCategories {
      id
      service_sub_cat_name
      service_category {
        id
        category_name
      }
      display_order
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_MATERIALS = gql`
  query ServiceMaterials {
    serviceMaterials {
      id
      service_material
      notes
      internal_note
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_MANUFACTURERS = gql`
  query GetServiceManufacturers {
    serviceManufacturers {
      id
      service_manufacturer
      is_active
    }
  }
`
export const GET_SERVICE_BRANDS = gql`
  query GetServiceBrands {
    serviceBrands {
      id
      service_brand
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_INDUSTRIES = gql`
  query ServiceIndustries {
    serviceIndustries {
      id
      service_type {
        id
        service_type
      }
      industry_category {
        id
        industry_category
      }
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_STANDARDS = gql`
  query ServiceStandards {
    serviceStandards {
      id
      service_std_name
      service_std_group
      service_std_no
      service_std_part
      service_std_year
      service_std_section
      service_std_fullname
      service_std_country
      service_std_published_date
      is_current
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_STANDARD_MATCH = gql`
  query ServiceStandardMatchList {
    serviceStandardMatchList {
      id
      service_sub_category {
        id
        service_sub_cat_name
      }
      service_standard {
        id
        service_std_name
      }
      notes
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_ADD_TYPES = gql`
  query ServiceAddTypes {
    serviceAddTypes {
      id
      service_add_type
      description
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_ADD_MANUFACTURERS = gql`
  query ServiceAddManufacturers {
    serviceAddManufacturers {
      id
      service_add_manufacturer
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_ADD_BRANDS = gql`
  query ServiceAddBrands {
    serviceAddBrands {
      id
      service_add_brand
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_ADD_GROUPS = gql`
  query ServiceAddGroups {
    serviceAddGroups {
      id
      service_add_group
      service_add_group_desc
      service_add_group_notes
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_ADDS = gql`
  query ServiceAdds {
    serviceAdds {
      id
      service_add
      service_add_desc
      service_add_material
      service_add_notes
      service_add_type {
        id
        service_add_type
      }
      service_add_manufacturer {
        id
        service_add_manufacturer
      }
      service_add_brand {
        id
        service_add_brand
      }
      service_add_group {
        id
        service_add_group
      }
      service_add_datasheet_url {
        id
        file_name
        cdn_url
        is_private_file
      }
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SERVICE_NOTES = gql`
  query GetServiceNotes {
    serviceNotes {
      id
      service_id
      service_name
      notes
      is_active
    }
  }
`
export const GET_SERVICE_CONFIGURATIONS = gql`
  query GetServiceConfigurations {
    serviceConfigurations {
      id
      service_config_name
      config_details
      is_active
    }
  }
`
export const GET_FITTING_TYPES = gql`
  query GetFittingTypes {
    fittingTypes {
      id
      fitting_type
      fitting_notes
      is_active
    }
  }
`
export const GET_FIXING_CATEGORIES = gql`
  query GetFixingCategories {
    fixingCategories {
      id
      fixing_category
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_FIXING_GROUPS = gql`
  query GetFixingGroups {
    fixingGroups {
      id
      fixing_group
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_FIXING_MATCHLIST = gql`
  query GetFixingMatchList {
    fixingMatchList {
      id
      fixing_group {
        id
        fixing_group
      }
      fixing_category {
        id
        fixing_category
      }
      inserted_on
      modified_on
    }
  }
`
export const GET_SEALING_METHODS = gql`
  query GetSealingMethods {
    sealingMethods {
      id
      sealing_method
      is_active
    }
  }
`
export const GET_APPLICATIONS = gql`
  query GetApplications {
    applications {
      id
      application_name
      application_display_order
      is_active
    }
  }
`

export const GET_FIXING_TESTED = gql`
  query GetFixingTested {
    fixingTested {
      id
      fixing_test_list
      fixing_required
      fixing_note
      internal_note
    }
  }
`
export const GET_INDUSTRY_CATEGORIES = gql`
  query GetIndustryCategories {
    industryCategories {
      id
      industry_category
      is_active
    }
  }
`
export const GET_SYSTEM_NOTE_TYPES = gql`
  query GetSystemNoteTypes {
    systemNoteTypes {
      id
      system_note_type
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SYSTEM_NOTES = gql`
  query GetSystemNotes {
    systemNotes {
      id
      report {
        id
        report_no
        report_name
      }
      report_ref
      note_title
      notes
      applies_to
      system_note_type {
        id
        system_note_type
      }
      report_note_no
      display
      build_sheet
      note_image_id
      internal_note
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SYSTEM_NOTES_MATCHLIST = gql`
  query GetSystemNotesMatchList {
    systemNotesMatchList {
      id
      system {
        id
        system_code
      }
      system_note {
        id
        notes
        note_title
      }
      is_active
      inserted_on
      modified_on
    }
  }
`
export const GET_SYSTEM_DOCS = gql`
  query systemDocs {
    systemDocs {
      id
      system_id
      system_code
      document_type {
        id
        document_type
      }
      document_url {
        id
        file_name
        cdn_url
        is_private_file
      }
      notes
      is_active
    }
  }
`
export const GET_DOCUMENT_TYPES = gql`
  query documentTypes {
    documentTypes {
      id
      document_type
      doc_type_desc
      is_active
    }
  }
`
export const GET_INQUIRIES = gql`
  query inquiries {
    inquiries {
      name
      email_address
      phone_number
      inquiry_type
      contact_preference
      email_content
      inquired_on
    }
  }
`
export const GET_HOMEPAGE_TILES = gql`
  query homePageTiles {
    homePageTiles {
      id
      tile_title
      tile_date
      tile_description
      tile_redirect_url
      tile_image_url {
        id
        cdn_url
        is_private_file
      }
      is_active
    }
  }
`
export const GET_QUALITY_CERTIFICATES = gql`
  query qualityCertificates {
    qualityCertificates {
      id
      certificate_name
      certificate_description
      certificate_url {
        id
        cdn_url
        is_private_file
      }
      is_active
      inserted_on
    }
  }
`
export const GET_FMP_PROJECTS = gql`
  query fmpProjects {
    fmpProjects {
      id
      project_name
      project_address
      subcontractor_name
      subcontractor_address
      subcontractor_logo
      revision
      date_created
      date_modified
      snap_user {
        first_name
        last_name
      }
    }
  }
`

export const GET_SNAP_USERS = gql`
  query SnapUsers {
    snapUsers {
      id
      first_name
      last_name
      email_address
      company_name
      address1
      address2
      suburb
      city
      state
      pincode
      company_logo
      supplier
      is_email_verified
      is_active
      created_on
      email_verified_on
      updated_on
      last_loggedin
    }
  }
`

export const GET_UNITS = gql`
  query units {
    units {
      id
      unit_name
      is_active
    }
  }
`
export const GET_DOCUMENT_VERSIONS = gql`
  query documentVersions {
    documentVersions {
      id
      version_desc
      version_abre
    }
  }
`
export const GET_DIMENSION_TYPES = gql`
  query dimensionTypes {
    dimensionTypes {
      id
      dim_type
      dim_description
    }
  }
`
export const GET_FRL_STANDARDS = gql`
  query frlStandards {
    frlStandards {
      id
      frl_type
      frl
      frl_st
      frl_integ
      frl_ins
      display_order
    }
  }
`
export const GET_FAQS = gql`
  query Faqs {
    faqs {
      id
      faq_q
      faq_a
      faq_image
      faq_information_reference
      display_order
      is_active
    }
  }
`

export const GET_COMPONENT_PRODUCTS = gql`
  query ComponentProducts {
    componentProducts {
      id
      comp_product_name
      product_type {
        id
        product_type
      }
      fire_rated
      product_manufacturer {
        id
        manufacturer_name
      }
      is_active
      notes
      inserted_on
      modified_on
    }
  }
`
export const GET_SYSTEM = gql`
  query Systems {
    systems {
      id
      system_code
      priority_order
      system_description
      service_configuration {
        id
        service_config_name
      }
      application {
        id
        application_name
      }
      industry_category {
        id
        industry_category
      }
      fixing_tested {
        fixing_test_list
        id
      }
      fixing_group {
        id
        fixing_group
      }
      fitting
      fitting_allowed
      fitting_type {
        id
        fitting_type
      }
      fitting_thickness
      penetration_depth
      penetration_depth_unit
      frl_actual
      frl_actual_st
      frl_actual_int
      frl_actual_ins
      frl_issued
      frl_issued_st
      frl_issued_int
      frl_issued_ins
      is_active
      multiple_services
      no_of_services
      system_elements {
        id
        element {
          id
          element_name
          element_abr
        }
        is_primary
      }
      system_products {
        id
        product {
          id
          product_code
          product_abr
        }
      }
      system_reports {
        id
        report {
          id
          report_name
        }
        penetration_no
        is_primary
      }
      display_record
      system_component_products {
        id
        component_product {
          id
          comp_product_name
        }
        component_product_details
      }
      system_services {
        id
        service {
          id
          service_name
          service_abr
        }
        is_range
        range_details
        quantity
      }

      system_docs {
        id
        document_type {
          id
          document_type
        }
        document_url {
          id
          file_name
          cdn_url
          is_private_file
        }
      }
      system_notes {
        id
        notes
        is_active
      }
      inserted_on
      modified_on
    }
  }
`
export const MUTATION_CREATE_ELEMENT = gql`
  mutation CreateElement($input: ElementInput) {
    createElement(input: $input)
  }
`
export const MUTATION_UPDATE_ELEMENT = gql`
  mutation UpdateElement($input: ElementInput) {
    updateElement(input: $input)
  }
`
export const MUTATION_DELETE_ELEMENT = gql`
  mutation Mutation($id: ID!) {
    deleteElement(id: $id)
  }
`
export const MUTATION_CREATE_PRODUCT = gql`
  mutation Mutation($input: ProductInput) {
    createProduct(input: $input)
  }
`
export const MUTATION_UPDATE_PRODUCT = gql`
  mutation UpdateProduct($input: ProductInput) {
    updateProduct(input: $input)
  }
`
export const MUTATION_DELETE_PRODUCT = gql`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id)
  }
`
export const MUTATION_SET_HERO_PHOTO = gql`
  mutation SetProductHeroPhoto($product_doc_id: ID!) {
    setProductHeroPhoto(product_doc_id: $product_doc_id)
  }
`
// Report
export const MUTATION_CREATE_REPORT = gql`
  mutation Mutation($input: ReportInput) {
    createReport(input: $input)
  }
`
export const MUTATION_UPDATE_REPORT = gql`
  mutation UpdateReport($input: ReportInput) {
    updateReport(input: $input)
  }
`
export const MUTATION_DELETE_REPORT = gql`
  mutation DeleteReport($id: ID!) {
    deleteReport(id: $id)
  }
`
// Report
export const MUTATION_CREATE_SERVICE = gql`
  mutation CreateService($input: ServiceInput) {
    createService(input: $input)
  }
`
export const MUTATION_UPDATE_SERVICE = gql`
  mutation UpdateService($input: ServiceInput) {
    updateService(input: $input)
  }
`
export const MUTATION_DELETE_SERVICE = gql`
  mutation DeleteService($id: ID!) {
    deleteService(id: $id)
  }
`

// ElementType
export const MUTATION_CREATE_ELEMENT_TYPE = gql`
  mutation Mutation($element_type: String!, $element_type_display_order: Int, $is_active: Boolean) {
    createElementType(element_type: $element_type, element_type_display_order: $element_type_display_order, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_ELEMENT_TYPE = gql`
  mutation Mutation($id: ID!, $is_active: Boolean, $element_type: String, $element_type_display_order: Int) {
    updateElementType(id: $id, element_type: $element_type, element_type_display_order: $element_type_display_order, is_active: $is_active)
  }
`
export const MUTATION_DELETE_ELEMENT_TYPE = gql`
  mutation Mutation($id: ID!) {
    deleteElementType(id: $id)
  }
`
// ElementMaterial
export const MUTATION_CREATE_ELEMENT_MATERIAL = gql`
  mutation Mutation($material_name: String!, $material_order: Int, $display_status: Boolean, $is_active: Boolean) {
    createElementMaterial(material_name: $material_name, material_order: $material_order, display_status: $display_status, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_ELEMENT_MATERIAL = gql`
  mutation Mutation($id: ID!, $material_name: String, $material_order: Int, $display_status: Boolean, $is_active: Boolean) {
    updateElementMaterial(
      id: $id
      material_name: $material_name
      material_order: $material_order
      display_status: $display_status
      is_active: $is_active
    )
  }
`
export const MUTATION_DELETE_ELEMENT_MATERIAL = gql`
  mutation Mutation($id: ID!) {
    deleteElementMaterial(id: $id)
  }
`
// ElementMaterialConf
export const MUTATION_CREATE_ELEMENT_MATERIAL_CONF = gql`
  mutation Mutation($material_name_id: Int!, $element_construction: String, $element_construction_abr: String, $is_active: Boolean) {
    createElementMaterialConf(
      material_name_id: $material_name_id
      element_construction: $element_construction
      element_construction_abr: $element_construction_abr
      is_active: $is_active
    )
  }
`
export const MUTATION_UPDATE_ELEMENT_MATERIAL_CONF = gql`
  mutation Mutation($id: ID!, $material_name_id: Int!, $element_construction: String, $element_construction_abr: String, $is_active: Boolean) {
    updateElementMaterialConf(
      id: $id
      material_name_id: $material_name_id
      element_construction: $element_construction
      element_construction_abr: $element_construction_abr
      is_active: $is_active
    )
  }
`
export const MUTATION_DELETE_ELEMENT_MATERIAL_CONF = gql`
  mutation Mutation($id: ID!) {
    deleteElementMaterialConf(id: $id)
  }
`
// ElementOrientation
export const MUTATION_CREATE_ELEMENT_ORIENTATION = gql`
  mutation Mutation($orientation: String!, $is_active: Boolean) {
    createElementOrientation(orientation: $orientation, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_ELEMENT_ORIENTATION = gql`
  mutation Mutation($id: ID!, $orientation: String, $is_active: Boolean) {
    updateElementOrientation(id: $id, orientation: $orientation, is_active: $is_active)
  }
`
export const MUTATION_DELETE_ELEMENT_ORIENTATION = gql`
  mutation Mutation($id: ID!) {
    deleteElementOrientation(id: $id)
  }
`

// ElementModType
export const MUTATION_CREATE_ELEMENT_MOD_TYPE = gql`
  mutation Mutation($element_mod_type: String!, $internal_note: String) {
    createElementModType(element_mod_type: $element_mod_type, internal_note: $internal_note)
  }
`
export const MUTATION_UPDATE_ELEMENT_MOD_TYPE = gql`
  mutation Mutation($id: ID!, $element_mod_type: String, $internal_note: String) {
    updateElementModType(id: $id, element_mod_type: $element_mod_type, internal_note: $internal_note)
  }
`
export const MUTATION_DELETE_ELEMENT_MOD_TYPE = gql`
  mutation Mutation($id: ID!) {
    deleteElementModType(id: $id)
  }
`
// ElementMod -- to be fixed
export const MUTATION_CREATE_ELEMENT_MOD = gql`
  mutation Mutation($element_mod_type_id: Int!, $element_mod_details: String!, $internal_note: String) {
    createElementMod(element_mod_type_id: $element_mod_type_id, element_mod_details: $element_mod_details, internal_note: $internal_note)
  }
`
export const MUTATION_UPDATE_ELEMENT_MOD = gql`
  mutation Mutation($id: ID!, $element_mod_type_id: Int, $element_mod_details: String, $internal_note: String) {
    updateElementMod(id: $id, element_mod_type_id: $element_mod_type_id, element_mod_details: $element_mod_details, internal_note: $internal_note)
  }
`
export const MUTATION_DELETE_ELEMENT_MOD = gql`
  mutation Mutation($id: ID!) {
    deleteElementMod(id: $id)
  }
`
// ProductInstallationType
export const MUTATION_CREATE_PRODUCT_INSTALLATION_TYPE = gql`
  mutation createProductInstallationType($installation_type: String!, $is_active: Boolean) {
    createProductInstallationType(installation_type: $installation_type, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_PRODUCT_INSTALLATION_TYPE = gql`
  mutation updateProductInstallationType($id: ID!, $installation_type: String, $is_active: Boolean) {
    updateProductInstallationType(id: $id, installation_type: $installation_type, is_active: $is_active)
  }
`
export const MUTATION_DELETE_PRODUCT_INSTALLATION_TYPE = gql`
  mutation Mutation($id: ID!) {
    deleteProductInstallationType(id: $id)
  }
`

// Product Matching List
export const MUTATION_CREATE_PRODUCT_MATCHING_LIST = gql`
  mutation createProductMatchingListItem(
    $current_product_id: Int
    $product_tested: String
    $is_active: Boolean
    $notes: String
    $internal_note: String
  ) {
    createProductMatchingListItem(
      current_product_id: $current_product_id
      product_tested: $product_tested
      is_active: $is_active
      notes: $notes
      internal_note: $internal_note
    )
  }
`
export const MUTATION_UPDATE_PRODUCT_MATCHING_LIST = gql`
  mutation updateProductMatchingListItem(
    $id: ID!
    $current_product_id: Int
    $product_tested: String
    $is_active: Boolean
    $notes: String
    $internal_note: String
  ) {
    updateProductMatchingListItem(
      id: $id
      current_product_id: $current_product_id
      product_tested: $product_tested
      is_active: $is_active
      notes: $notes
      internal_note: $internal_note
    )
  }
`
export const MUTATION_DELETE_PRODUCT_MATCHING_LIST = gql`
  mutation Mutation($id: ID!) {
    deleteProductMatchingListItem(id: $id)
  }
`

// Product Accessory Match
export const MUTATION_CREATE_PRODUCT_ACCESSORY_MATCH = gql`
  mutation createProductAccessoryMatch($accessoryId: Int, $productId: Int, $isActive: Boolean, $notes: String) {
    createProductAccessoryMatch(accessory_id: $accessoryId, product_id: $productId, is_active: $isActive, notes: $notes)
  }
`
export const MUTATION_UPDATE_PRODUCT_ACCESSORY_MATCH = gql`
  mutation UpdateProductAccessoryMatch($updateProductAccessoryMatchId: ID!, $accessoryId: Int, $productId: Int, $isActive: Boolean, $notes: String) {
    updateProductAccessoryMatch(
      id: $updateProductAccessoryMatchId
      accessory_id: $accessoryId
      product_id: $productId
      is_active: $isActive
      notes: $notes
    )
  }
`
export const MUTATION_DELETE_PRODUCT_ACCESSORY_MATCH = gql`
  mutation DeleteProductAccessoryMatch($deleteProductAccessoryMatchId: ID!) {
    deleteProductAccessoryMatch(id: $deleteProductAccessoryMatchId)
  }
`

// ProductType
export const MUTATION_CREATE_PRODUCT_TYPE = gql`
  mutation Mutation($product_type: String, $is_active: Boolean) {
    createProductType(product_type: $product_type, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_PRODUCT_TYPE = gql`
  mutation Mutation($id: ID!, $product_type: String, $is_active: Boolean) {
    updateProductType(id: $id, product_type: $product_type, is_active: $is_active)
  }
`
export const MUTATION_DELETE_PRODUCT_TYPE = gql`
  mutation Mutation($id: ID!) {
    deleteProductType(id: $id)
  }
`
// ProductCategory
export const MUTATION_CREATE_PRODUCT_CATEGORY = gql`
  mutation CreateProductCategory($category_name: String!, $is_active: Boolean, $category_display_order: Int) {
    createProductCategory(category_name: $category_name, is_active: $is_active, category_display_order: $category_display_order)
  }
`
export const MUTATION_UPDATE_PRODUCT_CATEGORY = gql`
  mutation UpdateProductCategory($id: ID!, $category_name: String, $is_active: Boolean, $category_display_order: Int) {
    updateProductCategory(id: $id, category_name: $category_name, is_active: $is_active, category_display_order: $category_display_order)
  }
`
export const MUTATION_DELETE_PRODUCT_CATEGORY = gql`
  mutation DeleteProductCategory($id: ID!) {
    deleteProductCategory(id: $id)
  }
`
export const MUTATION_CREATE_PRODUCT_SUB_CATEGORY = gql`
  mutation CreateProductSubCategory($input: ProductSubCategoryInput!) {
    createProductSubCategory(input: $input)
  }
`
export const MUTATION_UPDATE_PRODUCT_SUB_CATEGORY = gql`
  mutation UpdateProductSubCategory($input: ProductSubCategoryInput!) {
    updateProductSubCategory(input: $input)
  }
`
export const MUTATION_DELETE_PRODUCT_SUB_CATEGORY = gql`
  mutation DeleteProductSubCategory($id: ID!) {
    deleteProductSubCategory(id: $id)
  }
`
// ProductManufacturer
export const MUTATION_CREATE_PRODUCT_MANUFACTURER = gql`
  mutation CreateProductManufacturer($manufacturer_name: String!, $is_active: Boolean) {
    createProductManufacturer(manufacturer_name: $manufacturer_name, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_PRODUCT_MANUFACTURER = gql`
  mutation UpdateProductManufacturer($id: ID!, $manufacturer_name: String, $is_active: Boolean) {
    updateProductManufacturer(id: $id, manufacturer_name: $manufacturer_name, is_active: $is_active)
  }
`
export const MUTATION_DELETE_PRODUCT_MANUFACTURER = gql`
  mutation DeleteProductManufacturer($id: ID!) {
    deleteProductManufacturer(id: $id)
  }
`

// ProductBrand
export const MUTATION_CREATE_PRODUCT_BRAND = gql`
  mutation CreateProductBrand($brand_name: String!, $is_active: Boolean) {
    createProductBrand(brand_name: $brand_name, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_PRODUCT_BRAND = gql`
  mutation UpdateProductBrand($id: ID!, $brand_name: String, $is_active: Boolean) {
    updateProductBrand(id: $id, brand_name: $brand_name, is_active: $is_active)
  }
`
export const MUTATION_DELETE_PRODUCT_BRAND = gql`
  mutation DeleteProductBrand($id: ID!) {
    deleteProductBrand(id: $id)
  }
`

// Product Industries
export const MUTATION_CREATE_PRODUCT_INDUSTRY = gql`
  mutation CreateProductIndustry($product_id: String!, $industry_category_id: String!) {
    createProductIndustry(product_id: $product_id, industry_category_id: $industry_category_id)
  }
`
export const MUTATION_UPDATE_PRODUCT_INDUSTRY = gql`
  mutation UpdateProductIndustry($id: ID!, $product_id: String!, $industry_category_id: String!) {
    updateProductIndustry(id: $id, product_id: $product_id, industry_category_id: $industry_category_id)
  }
`
export const MUTATION_DELETE_PRODUCT_INDUSTRY = gql`
  mutation DeleteProductIndustry($id: ID!) {
    deleteProductIndustry(id: $id)
  }
`

// ProductInstructionList
export const MUTATION_CREATE_PRODUCT_INSTRUCTION_LIST = gql`
  mutation CreateProductInstructionListItem($input: ProductInstructionListInput) {
    createProductInstructionListItem(input: $input)
  }
`
export const MUTATION_UPDATE_PRODUCT_INSTRUCTION_LIST = gql`
  mutation UpdateProductInstructionListItem($input: ProductInstructionListInput) {
    updateProductInstructionListItem(input: $input)
  }
`
export const MUTATION_DELETE_PRODUCT_PRODUCT_INSTRUCTION_LIST = gql`
  mutation DeleteProductInstructionListItem($id: ID!) {
    deleteProductInstructionListItem(id: $id)
  }
`
// ReportType
export const MUTATION_CREATE_REPORT_TYPE = gql`
  mutation Mutation($report_type: String!, $is_active: Boolean) {
    createReportType(report_type: $report_type, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_REPORT_TYPE = gql`
  mutation Mutation($id: ID!, $report_type: String, $is_active: Boolean) {
    updateReportType(id: $id, report_type: $report_type, is_active: $is_active)
  }
`
export const MUTATION_DELETE_REPORT_TYPE = gql`
  mutation Mutation($id: ID!) {
    deleteReportType(id: $id)
  }
`
// ReportPublishing
export const MUTATION_CREATE_REPORT_PUBLISHING = gql`
  mutation CreateReportPublishing($release: String!, $publishing_details: String!, $is_active: Boolean) {
    createReportPublishing(release: $release, publishing_details: $publishing_details, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_REPORT_PUBLISHING = gql`
  mutation UpdateReportPublishing($id: ID!, $release: String, $publishing_details: String, $is_active: Boolean) {
    updateReportPublishing(id: $id, release: $release, publishing_details: $publishing_details, is_active: $is_active)
  }
`
export const MUTATION_DELETE_REPORT_PUBLISHING = gql`
  mutation Mutation($id: ID!) {
    deleteReportPublishing(id: $id)
  }
`
// ReportStatus
export const MUTATION_CREATE_REPORT_STATUS = gql`
  mutation CreateReportStatus($status: String!, $status_details: String!, $is_active: Boolean) {
    createReportStatus(status: $status, status_details: $status_details, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_REPORT_STATUS = gql`
  mutation UpdateReportStatus($id: ID!, $status: String, $status_details: String, $is_active: Boolean) {
    updateReportStatus(id: $id, status: $status, status_details: $status_details, is_active: $is_active)
  }
`
export const MUTATION_DELETE_REPORT_STATUS = gql`
  mutation Mutation($id: ID!) {
    deleteReportStatus(id: $id)
  }
`
// ReportStandardList
export const MUTATION_CREATE_REPORT_STANDARD_LIST = gql`
  mutation CreateReportStandardList(
    $standard_name: String!
    $standard_no: String!
    $standard_part: Int
    $standard_year: Int
    $standard_section: Int
    $standard_fullname: String!
    $standard_country: String!
    $standard_published_date: String
    $is_current: Boolean
    $is_active: Boolean
  ) {
    createReportStandardList(
      standard_name: $standard_name
      standard_no: $standard_no
      standard_part: $standard_part
      standard_year: $standard_year
      standard_section: $standard_section
      standard_fullname: $standard_fullname
      standard_country: $standard_country
      standard_published_date: $standard_published_date
      is_current: $is_current
      is_active: $is_active
    )
  }
`
export const MUTATION_UPDATE_REPORT_STANDARD_LIST = gql`
  mutation UpdateReportStandardList(
    $id: ID!
    $standard_name: String
    $standard_no: String
    $standard_part: Int
    $standard_year: Int
    $standard_section: Int
    $standard_fullname: String
    $standard_country: String
    $standard_published_date: String
    $is_current: Boolean
    $is_active: Boolean
  ) {
    updateReportStandardList(
      id: $id
      standard_name: $standard_name
      standard_no: $standard_no
      standard_part: $standard_part
      standard_year: $standard_year
      standard_section: $standard_section
      standard_fullname: $standard_fullname
      standard_country: $standard_country
      standard_published_date: $standard_published_date
      is_current: $is_current
      is_active: $is_active
    )
  }
`
export const MUTATION_DELETE_REPORT_STANDARD_LIST = gql`
  mutation Mutation($id: ID!) {
    deleteReportStandardList(id: $id)
  }
`
// ReportFacility
export const MUTATION_CREATE_REPORT_FACILITY = gql`
  mutation CreateReportFacility($facility: String!, $is_active: Boolean, $facility_country: String!) {
    createReportFacility(facility: $facility, is_active: $is_active, facility_country: $facility_country)
  }
`
export const MUTATION_UPDATE_REPORT_FACILITY = gql`
  mutation UpdateReportFacility($id: ID!, $facility: String, $facility_country: String, $is_active: Boolean) {
    updateReportFacility(id: $id, facility: $facility, facility_country: $facility_country, is_active: $is_active)
  }
`
export const MUTATION_DELETE_REPORT_FACILITY = gql`
  mutation DeleteReportFacility($id: ID!) {
    deleteReportFacility(id: $id)
  }
`
// Service Types
export const MUTATION_CREATE_SERVICE_TYPES = gql`
  mutation CreateServiceType($service_type: String!, $description: String, $is_active: Boolean) {
    createServiceType(service_type: $service_type, description: $description, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SERVICE_TYPES = gql`
  mutation UpdateServiceType($id: ID!, $service_type: String!, $description: String, $is_active: Boolean) {
    updateServiceType(id: $id, service_type: $service_type, description: $description, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SERVICE_TYPES = gql`
  mutation DeleteServiceType($id: ID!) {
    deleteServiceType(id: $id)
  }
`
// Service Category
export const MUTATION_CREATE_SERVICE_CATEGORY = gql`
  mutation CreateServiceCategory($input: ServiceCategoryInput) {
    createServiceCategory(input: $input)
  }
`
export const MUTATION_UPDATE_SERVICE_CATEGORY = gql`
  mutation UpdateServiceCategory($input: ServiceCategoryInput) {
    updateServiceCategory(input: $input)
  }
`
export const MUTATION_DELETE_SERVICE_CATEGORY = gql`
  mutation DeleteServiceCategory($id: ID!) {
    deleteServiceCategory(id: $id)
  }
`

// Service Sub Category
export const MUTATION_CREATE_SERVICE_SUB_CATEGORY = gql`
  mutation CreateServiceSubCategory($input: ServiceSubCategoryInput) {
    createServiceSubCategory(input: $input)
  }
`
export const MUTATION_UPDATE_SERVICE_SUB_CATEGORY = gql`
  mutation UpdateServiceSubCategory($input: ServiceSubCategoryInput) {
    updateServiceSubCategory(input: $input)
  }
`
export const MUTATION_DELETE_SERVICE_SUB_CATEGORY = gql`
  mutation DeleteServiceSubCategory($id: ID!) {
    deleteServiceSubCategory(id: $id)
  }
`

// Service Material
export const MUTATION_CREATE_SERVICE_MATERIALS = gql`
  mutation CreateServiceMaterial($service_material: String!, $notes: String, $internal_note: String, $is_active: Boolean) {
    createServiceMaterial(service_material: $service_material, notes: $notes, internal_note: $internal_note, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SERVICE_MATERIALS = gql`
  mutation UpdateServiceMaterial($id: ID!, $service_material: String, $notes: String, $internal_note: String, $is_active: Boolean) {
    updateServiceMaterial(id: $id, service_material: $service_material, notes: $notes, internal_note: $internal_note, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SERVICE_MATERIALS = gql`
  mutation DeleteServiceMaterial($id: ID!) {
    deleteServiceMaterial(id: $id)
  }
`

// Service Manufacturers
export const MUTATION_CREATE_SERVICE_MANUFACTURERS = gql`
  mutation CreateServiceManufacturer($service_manufacturer: String!, $is_active: Boolean) {
    createServiceManufacturer(service_manufacturer: $service_manufacturer, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SERVICE_MANUFACTURERS = gql`
  mutation UpdateServiceManufacturer($id: ID!, $service_manufacturer: String, $is_active: Boolean) {
    updateServiceManufacturer(id: $id, service_manufacturer: $service_manufacturer, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SERVICE_MANUFACTURERS = gql`
  mutation DeleteServiceManufacturer($id: ID!) {
    deleteServiceManufacturer(id: $id)
  }
`
// Service Brands
export const MUTATION_CREATE_SERVICE_BRANDS = gql`
  mutation CreateServiceBrand($service_brand: String!, $is_active: Boolean) {
    createServiceBrand(service_brand: $service_brand, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SERVICE_BRANDS = gql`
  mutation UpdateServiceBrand($id: ID!, $service_brand: String!, $is_active: Boolean) {
    updateServiceBrand(id: $id, service_brand: $service_brand, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SERVICE_BRANDS = gql`
  mutation DeleteServiceBrand($id: ID!) {
    deleteServiceBrand(id: $id)
  }
`

// Service Industry
export const MUTATION_CREATE_SERVICE_INDUSTRY = gql`
  mutation CreateServiceIndustry($input: ServiceIndustryInput) {
    createServiceIndustry(input: $input)
  }
`
export const MUTATION_UPDATE_SERVICE_INDUSTRY = gql`
  mutation UpdateServiceIndustry($input: ServiceIndustryInput) {
    updateServiceIndustry(input: $input)
  }
`
export const MUTATION_DELETE_SERVICE_INDUSTRY = gql`
  mutation DeleteServiceIndustry($id: ID!) {
    deleteServiceIndustry(id: $id)
  }
`
// Service Standards
export const MUTATION_CREATE_SERVICE_STANDARD = gql`
  mutation CreateServiceStandard($input: ServiceStandardInput) {
    createServiceStandard(input: $input)
  }
`
export const MUTATION_UPDATE_SERVICE_STANDARD = gql`
  mutation UpdateServiceStandard($input: ServiceStandardInput) {
    updateServiceStandard(input: $input)
  }
`
export const MUTATION_DELETE_SERVICE_STANDARD = gql`
  mutation DeleteServiceStandard($id: ID!) {
    deleteServiceStandard(id: $id)
  }
`

// Service Standard Match List
export const MUTATION_CREATE_SERVICE_STANDARD_MATCH = gql`
  mutation CreateServiceStandardMatch($input: ServiceStandardMatchInput) {
    createServiceStandardMatch(input: $input)
  }
`
export const MUTATION_UPDATE_SERVICE_STANDARD_MATCH = gql`
  mutation UpdateServiceStandardMatch($input: ServiceStandardMatchInput) {
    updateServiceStandardMatch(input: $input)
  }
`
export const MUTATION_DELETE_SERVICE_STANDARD_MATCH = gql`
  mutation DeleteServiceStandardMatch($id: ID!) {
    deleteServiceStandardMatch(id: $id)
  }
`

// Service Add Type
export const MUTATION_CREATE_SERVICE_ADD_TYPE = gql`
  mutation CreateServiceAddType($service_add_type: String!, $description: String, $is_active: Boolean) {
    createServiceAddType(service_add_type: $service_add_type, description: $description, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SERVICE_ADD_TYPE = gql`
  mutation UpdateServiceAddType($id: ID!, $service_add_type: String!, $description: String, $is_active: Boolean) {
    updateServiceAddType(id: $id, service_add_type: $service_add_type, description: $description, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SERVICE_ADD_TYPE = gql`
  mutation DeleteServiceAddType($id: ID!) {
    deleteServiceAddType(id: $id)
  }
`

// Service Add Manufacturer
export const MUTATION_CREATE_SERVICE_ADD_MANUFACTURER = gql`
  mutation CreateServiceAddManufacturer($service_add_manufacturer: String!, $is_active: Boolean) {
    createServiceAddManufacturer(service_add_manufacturer: $service_add_manufacturer, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SERVICE_ADD_MANUFACTURER = gql`
  mutation UpdateServiceAddManufacturer($id: ID!, $service_add_manufacturer: String, $is_active: Boolean) {
    updateServiceAddManufacturer(id: $id, service_add_manufacturer: $service_add_manufacturer, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SERVICE_ADD_MANUFACTURER = gql`
  mutation DeleteServiceAddManufacturer($id: ID!) {
    deleteServiceAddManufacturer(id: $id)
  }
`

// Service Add Brands
export const MUTATION_CREATE_SERVICE_ADD_BRAND = gql`
  mutation CreateServiceAddBrand($service_add_brand: String!, $is_active: Boolean) {
    createServiceAddBrand(service_add_brand: $service_add_brand, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SERVICE_ADD_BRAND = gql`
  mutation UpdateServiceAddBrand($id: ID!, $service_add_brand: String, $is_active: Boolean) {
    updateServiceAddBrand(id: $id, service_add_brand: $service_add_brand, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SERVICE_ADD_BRAND = gql`
  mutation DeleteServiceAddBrand($id: ID!) {
    deleteServiceAddBrand(id: $id)
  }
`

// Service Add Groups
export const MUTATION_CREATE_SERVICE_ADD_GROUP = gql`
  mutation CreateServiceAddGroup(
    $service_add_group: String!
    $service_add_group_desc: String
    $service_add_group_notes: String
    $is_active: Boolean
  ) {
    createServiceAddGroup(
      service_add_group: $service_add_group
      service_add_group_desc: $service_add_group_desc
      service_add_group_notes: $service_add_group_notes
      is_active: $is_active
    )
  }
`
export const MUTATION_UPDATE_SERVICE_ADD_GROUP = gql`
  mutation UpdateServiceAddGroup(
    $id: ID!
    $service_add_group: String
    $service_add_group_desc: String
    $service_add_group_notes: String
    $is_active: Boolean
  ) {
    updateServiceAddGroup(
      id: $id
      service_add_group: $service_add_group
      service_add_group_desc: $service_add_group_desc
      service_add_group_notes: $service_add_group_notes
      is_active: $is_active
    )
  }
`
export const MUTATION_DELETE_SERVICE_ADD_GROUP = gql`
  mutation UpdateServiceAddGroup($id: ID!) {
    deleteServiceAddGroup(id: $id)
  }
`

// Service Add
export const MUTATION_CREATE_SERVICE_ADD = gql`
  mutation CreateServiceAdd($input: ServiceAddInput) {
    createServiceAdd(input: $input)
  }
`
export const MUTATION_UPDATE_SERVICE_ADD = gql`
  mutation UpdateServiceAdd($input: ServiceAddInput) {
    updateServiceAdd(input: $input)
  }
`
export const MUTATION_DELETE_SERVICE_ADD = gql`
  mutation DeleteServiceAdd($id: ID!) {
    deleteServiceAdd(id: $id)
  }
`

// Service Configuration
export const MUTATION_CREATE_SERVICE_CONFIGURATION = gql`
  mutation CreateServiceConfiguration($service_config_name: String!, $config_details: String, $isActive: Boolean) {
    createServiceConfiguration(service_config_name: $service_config_name, config_details: $config_details, is_active: $isActive)
  }
`
export const MUTATION_UPDATE_SERVICE_CONFIGURATION = gql`
  mutation UpdateServiceConfiguration($id: ID!, $service_config_name: String, $config_details: String, $is_active: Boolean) {
    updateServiceConfiguration(id: $id, service_config_name: $service_config_name, config_details: $config_details, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SERVICE_CONFIGURATION = gql`
  mutation DeleteServiceConfiguration($id: ID!) {
    deleteServiceConfiguration(id: $id)
  }
`

// Fitting Type
export const MUTATION_CREATE_FITTING_TYPE = gql`
  mutation CreateFittingType($fitting_type: String!, $fitting_notes: String, $is_active: Boolean) {
    createFittingType(fitting_type: $fitting_type, fitting_notes: $fitting_notes, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_FITTING_TYPE = gql`
  mutation UpdateFittingType($id: ID!, $fitting_type: String, $fitting_notes: String, $is_active: Boolean) {
    updateFittingType(id: $id, fitting_type: $fitting_type, fitting_notes: $fitting_notes, is_active: $is_active)
  }
`
export const MUTATION_DELETE_FITTING_TYPE = gql`
  mutation DeleteFittingType($id: ID!) {
    deleteFittingType(id: $id)
  }
`
// Fixing Categories
export const MUTATION_CREATE_FIXING_MATCH = gql`
  mutation CreateFixingMatch($fixing_group_id: Int!, $fixing_category_id: Int!) {
    createFixingMatch(fixing_group_id: $fixing_group_id, fixing_category_id: $fixing_category_id)
  }
`
export const MUTATION_UPDATE_FIXING_MATCH = gql`
  mutation UpdateFixingMatch($id: ID!, $fixing_group_id: Int, $fixing_category_id: Int) {
    updateFixingMatch(id: $id, fixing_group_id: $fixing_group_id, fixing_category_id: $fixing_category_id)
  }
`
export const MUTATION_DELETE_FIXING_MATCH = gql`
  mutation DeleteFixingMatch($id: ID!) {
    deleteFixingMatch(id: $id)
  }
`
// Fixing Groups -- to be fixed
export const MUTATION_CREATE_FIXING_GROUP = gql`
  mutation CreateFixingGroup($fixing_group: String!, $is_active: Boolean) {
    createFixingGroup(fixing_group: $fixing_group, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_FIXING_GROUP = gql`
  mutation UpdateFixingGroup($id: ID!, $fixing_group: String, $is_active: Boolean) {
    updateFixingGroup(id: $id, fixing_group: $fixing_group, is_active: $is_active)
  }
`
export const MUTATION_DELETE_FIXING_GROUP = gql`
  mutation DeleteFixingGroup($id: ID!) {
    deleteFixingGroup(id: $id)
  }
`
// Fixing Match List -- to be fixed
export const MUTATION_CREATE_FIXING_CATEGORIES = gql`
  mutation CreateFixingCategory($fixing_category: String!, $is_active: Boolean) {
    createFixingCategory(fixing_category: $fixing_category, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_FIXING_CATEGORIES = gql`
  mutation UpdateFixingCategory($id: ID!, $fixing_category: String, $is_active: Boolean) {
    updateFixingCategory(id: $id, fixing_category: $fixing_category, is_active: $is_active)
  }
`
export const MUTATION_DELETE_FIXING_CATEGORIES = gql`
  mutation DeleteFixingCategory($id: ID!) {
    deleteFixingCategory(id: $id)
  }
`
// Sealing Methods
export const MUTATION_CREATE_SEALING_METHODS = gql`
  mutation CreateSealingMethod($sealing_method: String!, $is_active: Boolean) {
    createSealingMethod(sealing_method: $sealing_method, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SEALING_METHODS = gql`
  mutation UpdateSealingMethod($id: ID!, $sealing_method: String, $is_active: Boolean) {
    updateSealingMethod(id: $id, sealing_method: $sealing_method, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SEALING_METHODS = gql`
  mutation DeleteSealingMethod($id: ID!) {
    deleteSealingMethod(id: $id)
  }
`
// Create Application
export const MUTATION_CREATE_APPLICATION = gql`
  mutation CreateApplication($application_name: String!, $application_display_order: Int, $is_active: Boolean) {
    createApplication(application_name: $application_name, application_display_order: $application_display_order, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_APPLICATION = gql`
  mutation UpdateApplication($id: ID!, $application_name: String, $application_display_order: Int, $is_active: Boolean) {
    updateApplication(id: $id, application_name: $application_name, application_display_order: $application_display_order, is_active: $is_active)
  }
`
export const MUTATION_DELETE_APPLICATION = gql`
  mutation DeleteApplication($id: ID!) {
    deleteApplication(id: $id)
  }
`

// Create System Note TYpe
export const MUTATION_CREATE_SYSTEM_NOTE_TYPE = gql`
  mutation CreateSystemNoteType($system_note_type: String!, $is_active: Boolean) {
    createSystemNoteType(system_note_type: $system_note_type, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_SYSTEM_NOTE_TYPE = gql`
  mutation UpdateSystemNoteType($id: ID!, $system_note_type: String, $is_active: Boolean) {
    updateSystemNoteType(id: $id, system_note_type: $system_note_type, is_active: $is_active)
  }
`
export const MUTATION_DELETE_SYSTEM_NOTE_TYPE = gql`
  mutation DeleteSystemNoteType($id: ID!) {
    deleteSystemNoteType(id: $id)
  }
`

// Create System Note
export const MUTATION_CREATE_SYSTEM_NOTE = gql`
  mutation CreateSystemNote($input: SystemNoteInput) {
    createSystemNote(input: $input)
  }
`
export const MUTATION_UPDATE_SYSTEM_NOTE = gql`
  mutation UpdateSystemNote($input: SystemNoteInput) {
    updateSystemNote(input: $input)
  }
`
export const MUTATION_DELETE_SYSTEM_NOTE = gql`
  mutation DeleteSystemNote($id: ID!) {
    deleteSystemNote(id: $id)
  }
`

// Create System Note
export const MUTATION_CREATE_SYSTEM_NOTE_MATCH = gql`
  mutation CreateSystemNoteMatch($input: SystemNoteMatchInput) {
    createSystemNoteMatch(input: $input)
  }
`
export const MUTATION_UPDATE_SYSTEM_NOTE_MATCH = gql`
  mutation UpdateSystemNoteMatch($input: SystemNoteMatchInput) {
    updateSystemNoteMatch(input: $input)
  }
`
export const MUTATION_DELETE_SYSTEM_NOTE_MATCH = gql`
  mutation DeleteSystemNoteMatch($id: ID!) {
    deleteSystemNoteMatch(id: $id)
  }
`

export const MUTATION_CREATE_FIXING_TESTED = gql`
  mutation CreateFixingTested($fixing_test_list: String!, $fixing_required: Boolean, $fixing_note: String, $internal_note: String) {
    createFixingTested(
      fixing_test_list: $fixing_test_list
      fixing_required: $fixing_required
      fixing_note: $fixing_note
      internal_note: $internal_note
    )
  }
`
export const MUTATION_UPDATE_FIXING_TESTED = gql`
  mutation UpdateFixingTested($id: ID!, $fixing_test_list: String!, $fixing_required: Boolean, $fixing_note: String, $internal_note: String) {
    updateFixingTested(
      id: $id
      fixing_test_list: $fixing_test_list
      fixing_required: $fixing_required
      fixing_note: $fixing_note
      internal_note: $internal_note
    )
  }
`
export const MUTATION_DELETE_FIXING_TESTED = gql`
  mutation DeleteFixingTested($id: ID!) {
    deleteFixingTested(id: $id)
  }
`

// Create DocumentType
export const MUTATION_CREATE_DOCUMENT_TYPE = gql`
  mutation CreateDocumentType($document_type: String!, $doc_type_desc: String!, $is_active: Boolean) {
    createDocumentType(document_type: $document_type, doc_type_desc: $doc_type_desc, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_DOCUMENT_TYPE = gql`
  mutation UpdateDocumentType($id: ID!, $document_type: String, $doc_type_desc: String, $is_active: Boolean) {
    updateDocumentType(id: $id, document_type: $document_type, doc_type_desc: $doc_type_desc, is_active: $is_active)
  }
`
export const MUTATION_DELETE_DOCUMENT_TYPE = gql`
  mutation DeleteDocumentType($id: ID!) {
    deleteDocumentType(id: $id)
  }
`

// Industry Category
export const MUTATION_CREATE_INDUSTRY_CATEGORY = gql`
  mutation CreateIndustryCategory($industry_category: String!, $is_active: Boolean) {
    createIndustryCategory(industry_category: $industry_category, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_INDUSTRY_CATEGORY = gql`
  mutation UpdateIndustryCategory($id: ID!, $industry_category: String, $is_active: Boolean) {
    updateIndustryCategory(id: $id, industry_category: $industry_category, is_active: $is_active)
  }
`
export const MUTATION_DELETE_INDUSTRY_CATEGORY = gql`
  mutation DeleteIndustryCategory($id: ID!) {
    deleteIndustryCategory(id: $id)
  }
`
// Units
export const MUTATION_CREATE_UNITS = gql`
  mutation CreateUnit($unit_name: String!, $is_active: Boolean) {
    createUnit(unit_name: $unit_name, is_active: $is_active)
  }
`
export const MUTATION_UPDATE_UNITS = gql`
  mutation UpdateUnit($id: ID!, $unit_name: String, $is_active: Boolean) {
    updateUnit(id: $id, unit_name: $unit_name, is_active: $is_active)
  }
`
export const MUTATION_DELETE_UNITS = gql`
  mutation DeleteUnit($id: ID!) {
    deleteUnit(id: $id)
  }
`

// Document Version
export const MUTATION_CREATE_DOCUMENT_VERSION = gql`
  mutation createDocumentVersion($version_desc: String!, $version_abre: String!) {
    createDocumentVersion(version_desc: $version_desc, version_abre: $version_abre)
  }
`
export const MUTATION_UPDATE_DOCUMENT_VERSION = gql`
  mutation updateDocumentVersion($id: ID!, $version_desc: String, $version_abre: String) {
    updateDocumentVersion(id: $id, version_desc: $version_desc, version_abre: $version_abre)
  }
`
export const MUTATION_DELETE_DOCUMENT_VERSION = gql`
  mutation DeleteDocumentVersion($id: ID!) {
    deleteDocumentVersion(id: $id)
  }
`

// Dimension Types
export const MUTATION_CREATE_DIMENSION_TYPE = gql`
  mutation createDimensionType($dim_type: String!, $dim_description: String!) {
    createDimensionType(dim_type: $dim_type, dim_description: $dim_description)
  }
`
export const MUTATION_UPDATE_DIMENSION_TYPE = gql`
  mutation updateDimensionType($id: ID!, $dim_type: String, $dim_description: String) {
    updateDimensionType(id: $id, dim_type: $dim_type, dim_description: $dim_description)
  }
`
export const MUTATION_DELETE_DIMENSION_TYPE = gql`
  mutation DeleteDimensionType($id: ID!) {
    deleteDimensionType(id: $id)
  }
`

//FRL Standards
export const MUTATION_CREATE_FRL_STANDARD = gql`
  mutation createFRLStandard($frl_type: String!, $frl_st: Int!, $frl_integ: Int!, $frl_ins: Int!, $display_order: Int) {
    createFRLStandard(frl_type: $frl_type, frl_st: $frl_st, frl_integ: $frl_integ, frl_ins: $frl_ins, display_order: $display_order)
  }
`
export const MUTATION_UPDATE_FRL_STANDARD = gql`
  mutation updateFRLStandard($id: ID!, $frl_type: String, $frl_st: Int, $frl_integ: Int, $frl_ins: Int, $display_order: Int) {
    updateFRLStandard(id: $id, frl_type: $frl_type, frl_st: $frl_st, frl_integ: $frl_integ, frl_ins: $frl_ins, display_order: $display_order)
  }
`
export const MUTATION_DELETE_FRL_STANDARD = gql`
  mutation deleteFRLStandard($id: ID!) {
    deleteFRLStandard(id: $id)
  }
`

//FAQs
export const MUTATION_CREATE_FAQ = gql`
  mutation createFAQ(
    $faq_q: String!
    $faq_a: String!
    $faq_image: String
    $faq_information_reference: String
    $display_order: Int
    $is_active: Boolean
  ) {
    createFAQ(
      faq_q: $faq_q
      faq_a: $faq_a
      faq_image: $faq_image
      faq_information_reference: $faq_information_reference
      display_order: $display_order
      is_active: $is_active
    )
  }
`
export const MUTATION_UPDATE_FAQ = gql`
  mutation updateFAQ(
    $id: ID!
    $faq_q: String
    $faq_a: String
    $faq_image: String
    $faq_information_reference: String
    $display_order: Int
    $is_active: Boolean
  ) {
    updateFAQ(
      id: $id
      faq_q: $faq_q
      faq_a: $faq_a
      faq_image: $faq_image
      faq_information_reference: $faq_information_reference
      display_order: $display_order
      is_active: $is_active
    )
  }
`
export const MUTATION_DELETE_FAQ = gql`
  mutation DeleteFAQ($id: ID!) {
    deleteFAQ(id: $id)
  }
`

export const MUTATION_CREATE_COMPONENT_PRODUCT = gql`
  mutation CreateComponentProduct($input: ComponentProductInput) {
    createComponentProduct(input: $input)
  }
`
export const MUTATION_UPDATE_COMPONENT_PRODUCT = gql`
  mutation UpdateComponentProduct($input: ComponentProductInput) {
    updateComponentProduct(input: $input)
  }
`
export const MUTATION_DELETE_COMPONENT_PRODUCT = gql`
  mutation Mutation($id: ID!) {
    deleteComponentProduct(id: $id)
  }
`
// System
export const MUTATION_CREATE_SYSTEM = gql`
  mutation CreateSystem($input: SystemInput) {
    createSystem(input: $input)
  }
`
export const MUTATION_UPDATE_SYSTEM = gql`
  mutation UpdateSystem($input: SystemInput) {
    updateSystem(input: $input)
  }
`
export const MUTATION_DELETE_SYSTEM = gql`
  mutation DeleteSystem($id: ID!) {
    deleteSystem(id: $id)
  }
`
// Create Home Page Tile
export const MUTATION_CREATE_HOMEPAGE_TILE = gql`
  mutation CreateHomePageTile($input: HomePageTileInput) {
    createHomePageTile(input: $input)
  }
`
export const MUTATION_UPDATE_HOMEPAGE_TILE = gql`
  mutation UpdateHomePageTile($input: HomePageTileInput) {
    updateHomePageTile(input: $input)
  }
`
export const MUTATION_DELETE_HOMEPAGE_TILE = gql`
  mutation DeleteHomePageTile($id: ID!) {
    deleteHomePageTile(id: $id)
  }
`
// Quality Certificate
export const MUTATION_CREATE_QUALITY_CERTIFICATE = gql`
  mutation CreateQualityCertificate($input: QualityCertificateInput) {
    createQualityCertificate(input: $input)
  }
`
export const MUTATION_UPDATE_QUALITY_CERTIFICATE = gql`
  mutation UpdateQualityCertificate($input: QualityCertificateInput) {
    updateQualityCertificate(input: $input)
  }
`
export const MUTATION_DELETE_QUALITY_CERTIFICATE = gql`
  mutation DeleteQualityCertificate($id: ID!) {
    deleteQualityCertificate(id: $id)
  }
`
